<template>
  <div>
    <a-skeleton active :loading="loading" :title="false" :paragraph="{ rows: 8, width: 800 }">
      <a-list :dataSource="invoices" itemLayout="horizontal" :grid="{ size: 'middle'}">
        <a-list-item slot="renderItem" slot-scope="invoice" :rowKey="invoice.id">
          <a
            :href="invoice.hosted_invoice_url"
            target="_blank"
            slot="actions"
            style="color: rgba(0, 0, 0, 0.45) !important;"
          >
            <a-icon type="download" style="padding:5px; font-size:20px;"></a-icon>Download Invoice
          </a>
          <div class="container">
            <p>
              <a-icon
                type="check-circle"
                theme="twoTone"
                twoToneColor="#52c41a"
                style="margin-right:5px;"
              />Paid
            </p>
          </div>
          <a-list-item-meta>
            <p slot="description">Amount: US${{invoice.amount_paid | centavo}}</p>
            <a slot="title">
              <b>{{invoice.period_start | moment}} - {{invoice.period_end | moment}}</b>
            </a>

            <a-avatar
              slot="avatar"
              shape="square"
              :size="48"
              style="background: #002e66;"
              icon="file-pdf"
            />
          </a-list-item-meta>
        </a-list-item>
      </a-list>
    </a-skeleton>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      loading: true,
      invoices: []
    };
  },
  computed: {
    ...mapGetters("core", ["customer_id", "subscription_id", "list_invoices"])
  },
  beforeCreate: async function() {
    try {
      this.loading = true;
      var data = await this.$store.dispatch("core/getItems", {
        endpoint: `tenants/${this.$auth.session.org}/invoices`
      });
      this.invoices = data.results;
      this.loading = false;
    } catch (error) {
      console.error(error);
      this.loading = false;
    }
  },
  filters: {
    moment: function(date) {
      return moment.unix(date).format("MMM Do YYYY");
    },
    centavo: function(value) {
      return value / 100;
    }
  }
};
</script>